import styled from 'styled-components'

export const ItemWrapper = styled.div`
  width: 226px;
`

export const FilterWrapper = styled.div`
  display: flex;
  gap: 30px;
`
